import data from './data/voting_access.json';
import geo from './data/us_albers.json';

export default function (props) {
  const { initialWidth } = props;

  return {
    data,
    geo,
    width: initialWidth,
  };
}
